const apiUrl = 'https://www.jxcgny.cn/api'
// const apiUrl = 'http://127.0.0.1:9090/api'

export default {
    apiUrl
}


//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = null
// module chunks = 